import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";

const Loading = ({ fullscreen, onTop, circularProgressSize }) => (
  <div
    className={`loading ${fullscreen ? "fullscreen" : "inline"} ${
      onTop ? "on-top" : ""
    }`}
  >
    <div className="loading-container">
      {fullscreen && (
        <img
          className="w-100"
          src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`}
          alt="Cargando..."
        />
      )}
      {fullscreen ? (
        <LinearProgress className="mt-2" />
      ) : (
        <CircularProgress size={circularProgressSize} />
      )}
    </div>
  </div>
);

export default Loading;
